import { Module } from 'vuex'
import { RootState, LabsFeatures } from './state_models'
import LocationsService from '../services/LocationsService'

export const labsFeatures: Module<LabsFeatures, RootState> = {
    namespaced: true,
    state: { features: [], fetched:false, companyFeatures: [], companyFetched: false },
    getters: {
      getAll: (state: LabsFeatures) => {
        return state.features
      },
      getAllCompanyFeatures: (state: LabsFeatures) => {
        return state.companyFeatures
      },
    },
    mutations:{
        setFeatures(state,value) {
            state.features = value
            state.fetched = true
        },
        setCompanyFeatures(state,value) {
          state.companyFeatures = value
          state.companyFetched = true
      }
    },
    actions:{
       async fetchAll(context, data: { type: 'location' | 'company'}){
          if (data.type == 'location') {
            if(context.state.fetched)
            return context.state.features

            const features = await LocationsService.getLabsFeatures()

            context.commit('setFeatures',features);
            return features;
          }
          if (data.type == 'company') {
            if(context.state.companyFetched)
            return context.state.companyFeatures

            const features = await LocationsService.getLabsFeatures('company')

            context.commit('setCompanyFeatures',features);
            return features;
          }
        }
    }
}